export default {
    productMapping: 'Product mappings',
    productMappingSubtitle: label =>
        `Connect your products in CyberFOX Password Manager with your product in ${label} to allow CyberFOX Password Manager to update your ${label} Agreements`,
    productMappingEmpty: 'You do not have any product mapping yet',
    productMappingPBColumn: 'CyberFOX Product',
    productMappingIntegrationColumn: label => `${label} Product`,
    companyMappingAgreementColumn: config =>
        `${config.label} ${config.agreementLabel}`,
};
